module.exports = __webpack_public_path__ + "img/menu_slider_docsign.2d86e64f.png";